import './card-carousel-slider.css';

import classNames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import Slider from 'react-slick';

import FacebookIcon from '../../assets/svg/facebook-alternate.inline.svg';
import InstagramIcon from '../../assets/svg/instagram.inline.svg';
import LinkIcon from '../../assets/svg/link.inline.svg';
import LinkedInIcon from '../../assets/svg/linkedin.inline.svg';
import TiktokIcon from '../../assets/svg/tiktok.inline.svg';
import { AlmaLink } from '../alma-link';
import { BrandIcon } from '../brand-icon';
import { PortableText } from '../portableText';
import * as styles from './stacks-card-carousel.module.css';

const sliderSettings = {
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	dots: true,
	arrows: false,
	speed: 700,
	autoplaySpeed: 10000,
};

export function StacksCardCarousel({ cards, contentOrder, imageAspectRatio }) {
	return (
		<Slider
			{...sliderSettings}
			className={classNames(
				'slick-list',
				styles.moduleContainer,
				'card-carousel'
			)}
		>
			{cards?.map((card, index) => {
				const {
					_id,
					_rawDescription,
					ctaLink,
					ctaTitle,
					brandIcon,
					image,
					link,
					title,
					socialLinks,
					subtitle,
				} = card;

				const imageData = getImage(image?.asset);

				const dynamicContent = contentOrder?.map((content, index) => {
					let element = null;

					switch (content) {
						case 'icon':
							brandIcon
								? (element = (
										<div key={`${content}-${index}`}>
											<BrandIcon icon={brandIcon} />
										</div>
									))
								: (element = null);
							break;
						case 'image':
							link && imageData
								? (element = (
										<a
											href={link}
											key={`${content}-${index}`}
											rel='noopener noreferrer'
											target='_blank'
										>
											<GatsbyImage
												alt={image?.alt || ''}
												className={classNames(
													imageAspectRatio &&
														styles[imageAspectRatio]
												)}
												image={imageData}
											/>
										</a>
									))
								: imageData
									? (element = (
											<GatsbyImage
												alt={image?.alt || ''}
												className={classNames(
													imageAspectRatio &&
														styles[imageAspectRatio]
												)}
												image={imageData}
												key={`${content}-${index}`}
											/>
										))
									: (element = null);
							break;
						case 'title':
							link
								? (element = (
										<a
											href={link}
											key={`${content}-${index}`}
											rel='noopener noreferrer'
											target='_blank'
										>
											<h3 className='card-title'>
												{title}
											</h3>
										</a>
									))
								: (element = (
										<h3
											className='card-title'
											key={`${content}-${index}`}
										>
											{title}
										</h3>
									));
							break;
						case 'subtitle':
							subtitle
								? (element = (
										<p key={`${content}-${index}`}>
											<strong>{subtitle}</strong>
										</p>
									))
								: (element = null);
							break;
						case 'description':
							_rawDescription
								? (element = (
										<PortableText
											blocks={_rawDescription}
											key={`${content}-${index}`}
										/>
									))
								: (element = null);
							break;
						case 'cta':
							ctaLink && ctaTitle
								? (element = (
										<div>
											<AlmaLink
												cta={{
													title: ctaTitle,
													link: ctaLink,
												}}
												key={`${content}-${index}`}
											/>
										</div>
									))
								: (element = null);
							break;
						case 'socialLinks':
							socialLinks && socialLinks?.length > 0
								? (element = (
										<div
											className='socialLinks'
											key={`${content}-${index}`}
										>
											<p>Personal links:</p>
											<div>
												{socialLinks.map(
													(socialLink, index) => {
														const { icon, link } =
															socialLink;

														return (
															<a
																href={link}
																key={`${icon}-${index}`}
																rel='noopener noreferrer'
																target='_blank'
															>
																{icon ===
																	'instagram' && (
																	<InstagramIcon />
																)}
																{icon ===
																	'website' && (
																	<LinkIcon />
																)}
																{icon ===
																	'linkedin' && (
																	<LinkedInIcon />
																)}
																{icon ===
																	'tiktok' && (
																	<TiktokIcon />
																)}
																{icon ===
																	'facebook' && (
																	<FacebookIcon />
																)}
															</a>
														);
													}
												)}
											</div>
										</div>
									))
								: (element = null);
							break;
						default:
							element = null;
					}

					return element;
				});

				return (
					<div
						className={classNames(styles.cardContainer)}
						key={`${_id}-${index}`}
					>
						{dynamicContent}
					</div>
				);
			})}
		</Slider>
	);
}
